import React from 'react'

export const HeroSectionData = {
    sendInvitation: {
        HERO_TITLE_LINE_1: "Smart Invitation System",
        HERO_TITLE_LINE_2: "Plan Events with Confidence!",
        HERO_TITLE_LINE_3: "Invite & Track Guests Effortlessly.",
        HERO_SUBTITLE: "Send Invitations and Track RSVPs in Real-Time",
        HERO_DESCRIPTION:
            "Easy Guest Management with WhatsApp Invites and Live Response Tracking.",
        SIGN_UP_BUTTON_TEXT: "Sign up",
        CATERING_BUTTON_TEXT: 'Try our "Invitations" Feature',
        CONFIRM_DIALOG_HEADER: "Please Login or Sign-Up",
        CONFIRM_DIALOG_MESSAGE: "Login to check how easy it is!",
    },

    bookPriest: {
        HERO_TITLE_LINE_1: "Book Expert Priests for Any Occasion!",
        HERO_TITLE_LINE_2: "Poojas, Funerals, and More – Hassle-Free",
        HERO_TITLE_LINE_3: "Anytime. Anywhere.",
        HERO_SUBTITLE: "Qualified & Verified Priests at Your Fingertips",
        HERO_DESCRIPTION:
            "Find trusted priests with transparent pricing and great discounts.",
        SIGN_UP_BUTTON_TEXT: "Sign up",
        CATERING_BUTTON_TEXT: "Book a Priest",
        CONFIRM_DIALOG_HEADER: "Please Login or Sign-Up",
        CONFIRM_DIALOG_MESSAGE: "Login to explore our priest services!",
    },

    aienabledevent: {
         HERO_TITLE_LINE_1: "AI-Powered Event Proceedings",
        HERO_TITLE_LINE_2: "Plan Poojas and Funerals with Confidence!",
        HERO_SUBTITLE :"Get step-by-step guidance",
        HERO_TITLE_LINE_3 :"for any event.",
        HERO_DESCRIPTION:
            "Discover Step-by-Step Rituals and proceedings of the event ",
        SIGN_UP_BUTTON_TEXT: "Sign up",
        CATERING_BUTTON_TEXT: "TRY AI-ENABLED",
        CONFIRM_DIALOG_HEADER: "Please Login or Sign-Up",
        CONFIRM_DIALOG_MESSAGE: "Login to check how easy it is!",
      
      },

      bookcatering: {
        HERO_TITLE_LINE_1 : "Effortlessly compare",
        HERO_TITLE_LINE_2 : "caterers.",
        HERO_SUBTITLE : "Choose the best",
        HERO_TITLE_LINE_3 : "for any occasion.",
        HERO_DESCRIPTION :
        "From poojas to funerals, weddings to birthdays – find the best caterers with just a few taps. Start Planning Smarter—Join Thurent Now!",
        SIGN_UP_BUTTON_TEXT :"Sign up",
        CATERING_BUTTON_TEXT : "See catering in your area",
        CONFIRM_DIALOG_HEADER : "Please Login or Sign-Up",
        CONFIRM_DIALOG_MESSAGE : "Login to check how easy it is!",
      },

      rentFormTentHouse: {

         HERO_TITLE_LINE_1 : "Rent Tables, Chairs, Plates, and More!",
         HERO_TITLE_LINE_2 : "From Trusted Tent Houses Near You",
         HERO_TITLE_LINE_3 : "All in One Place",
         HERO_SUBTITLE : "Your One-Stop Event Rental Solution",
        cHERO_DESCRIPTION :
          "Tables, chairs, plates and spoons etc. to choose from approved vendors at discounted prices.",
         SIGN_UP_BUTTON_TEXT : "Sign up",
         CATERING_BUTTON_TEXT : "Rent from Tent Houses",
         CONFIRM_DIALOG_HEADER : "Please Login or Sign-Up",
         CONFIRM_DIALOG_MESSAGE : "Login to rent event supplies with Thurent.",
      },
    
};